import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { get } from 'lodash';

import { IError } from 'ui/interfaces/entities/apiError';
// import errorAction from "ui/reducers/error/action";
// import store from "ui/reducers/store";
import { baseURL } from 'ui/config';
import { action } from 'ui/reducers/error';

axios.interceptors.request.use(config => {
  // when we are running inside engine
  if ((window as any).datashop) {
    const appConfig = (window as any).datashop.app.module('getPublicConfig')('patient');
    const {
      host,
      api: { base },
    } = appConfig;
    const BASE_URL = `${host}${base}`;

    return {
      ...config,
      baseURL: BASE_URL,
      withCredentials: true,
    };
  } else {
    const token = localStorage.getItem('auth.token.active');

    return {
      ...config,
      baseURL,
      headers: {
        ...config.headers,
        Authorization: `Authorization ${token}`,
      },
    };
  }
});

axios.interceptors.response.use(
  response => response,
  e => {
    let error = e;
    if (!e.response) {
      error = {
        ...e,
        response: {
          data: {
            statusCode: 900,
            error: {
              message: 'Network error. Please check your internet connection.',
            },
          },
        },
      };
    } else if (e.response.status === 401) {
      window.location = (window as any).skeletonPwa.container.siteprefix('/api/auth/logout');
    } else if (typeof e.response.data === 'string') {
      error = {
        ...e,
        response: {
          ...e.response,
          originalData: e.response.data,
          data: { statusCode: 0, error: { message: 'Something went wrong' } },
        },
      };
    }

    if (error.config.showErrorSnackbar || process.env.NODE_ENV !== 'production') {
      action.setError(get(error, 'response.data.error.message', 'Something went wrong'));
      // store.dispatch(
      //   errorAction.setError(
      //     get(error, "response.data.error.message", "Something went wrong")
      //   )
      // );
    }

    return Promise.reject({
      ...error,
      response: { ...error.response, data: error.response.data.error },
    });
  },
);

export default axios;

export interface IAxiosResponseError<T = IError> {
  config: AxiosRequestConfig;
  request?: any;
  response: AxiosResponse<T>;
}
